import { PersonaType } from '@/modules/auth/domain/models/Persona'

import { axios, Response } from '../index'

export interface GroupUsers {
  id: number
  name: string
  personaType: PersonaType
  permissions: string[]
  users: User[]
  automationGroups: AutomationGroup[]
}

export interface User {
  id: number
  name: string
  avatar: string
  accessId: number
  automationGroupTherapists: AutomationGroupTherapist[]
}

export interface AutomationGroupTherapist {
  id: string
  userId: number
  accessProfileId: number
  personaId: string
  used: boolean
  groupCategory: string
}

export interface AutomationGroup {
  id: string
  accessProfileId: number
  groupCategory: string
  used: boolean
}

export default async function listGroupUsers(): Response<GroupUsers[]> {
  return await axios.get('/v2/profiles')
}
